import React, {useCallback} from "react";
import {Alert, FormControl, FormControlLabel, Grid, Radio, RadioGroup, TextField} from "@mui/material";
import {useAppDispatch, useAppSelector} from "../../store";
import {setPreferencesPartial} from "../../store/expertise/expertise.reducer";
import {Caption, Title} from "../shared/Texts";
import {ClotureAfterValidator} from "../../../core/validators/cloture.after.validator";

export default function ClotureAuto() {
	const dispatch = useAppDispatch();
	const { preferences, user } = useAppSelector((s) => ({
		preferences: s.expertise.preferences,
		user: s.auth.user,
	}));
	const clotureAuto = preferences?.preferencesClotureAuto?.clotureAuto ?? false;
	const clotureAfter = preferences?.preferencesClotureAuto?.clotureAfter;

	const setClotureAuto = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			dispatch(
				setPreferencesPartial({
					preferencesClotureAuto: {
						clotureAuto: e.target.value === "true",
					}
				})
			);
		},
		[dispatch]
	);

	const setClotureAfter = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			dispatch(
				setPreferencesPartial({
					preferencesClotureAuto: {
						clotureAfter: parseInt(e.target.value, 10),
					}
				})
			);
		},
		[dispatch]
	);

	const isInputInvalid = clotureAuto && !ClotureAfterValidator.validate(clotureAfter);
	if (!preferences || !user) return null;

	return (
		<Grid container direction={"column"}>
			<Grid item>
				<Title text={"Clôture des téléexpertises"}/>
			</Grid>
			<Grid item marginTop={2}>
				<Grid item marginTop={0.5}>
					<Caption text={"Après avoir finalisé vos téléexpertises, vous pouvez choisir de clôturer la conversation en y bloquant les échanges."} />
				</Grid>
				<FormControl component="fieldset">
					<RadioGroup value={clotureAuto} onChange={setClotureAuto} name="radio-buttons-group-cloture">
						<FormControlLabel
							value="false"
							control={<Radio/>}
							label="Je ne souhaite pas programmer la clôture automatique de mes téléexpertises après leur finalisation"
						/>
						<Grid container alignItems={"center"}>
							<Grid item>
								<FormControlLabel
									value="true"
									control={<Radio/>}
									label={
										<Grid container alignItems="center" wrap="nowrap" spacing={1}>
											<Grid item>
												Je souhaite que mes téléexpertises soient clôturées automatiquement
											</Grid>

											<Grid item>
												<TextField
													key={user!.idTechPs}
													variant="standard"
													type="number"
													inputProps={{
														style: {width: "60px", textAlign: "center"},
														min: 0,
													}}
													error={isInputInvalid}
													disabled={!clotureAuto}
													sx={!clotureAuto ? {backgroundColor: (theme) => theme.palette.action.disabledBackground} : undefined}
													onChange={setClotureAfter}
													value={clotureAfter}
													onClick={(e) => e.stopPropagation()}
												/>
											</Grid>
											<Grid item>
												jour(s) après leur finalisation
											</Grid>
										</Grid>
									}
								/>
							</Grid>
						</Grid>
					</RadioGroup>
				</FormControl>
			</Grid>
			<Grid item marginLeft={4} marginTop={0.5}>
				<Caption
					text={
						"Les téléexpertises seront clôturées automatiquement pendant la nuit suivant la date de clôture."
					}
				/>
			</Grid>
			<Alert severity="warning" sx={{marginTop: 2, marginBottom: 1}}><strong>Attention</strong> : à l'activation
				de la clôture automatique, celle-ci sera appliquée sur toutes vos téléexpertises déjà finalisées. Vous
				pourrez ensuite les ouvrir manuellement au besoin.</Alert>
		</Grid>
	);
}
